<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Instructor Subject Registration Information</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            @click="putnull" persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" @click="putnull"
            persistent-hint hint="Please Select Standard" />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
            hint="Please Select Division" />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data && div">
          <v-btn class="mt-6 button" @click="getData()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
      <span v-if="mainList != '' && mainList != null">
        <!-- <download-excel
          class="mr-2 pb-3 pt-2"
          :data="mainList"
          :fields="table_fields"
          worksheet="Student_List"
          name="SubjectRegistrationData.xls"
        >
          <v-btn color="success" outlined rounded>
            <v-icon dark>mdi-file-excel</v-icon> Export
          </v-btn>
        </download-excel> -->

        <!-- shiv change code -->
        <!-- <v-btn class="exportbtn" color="success" outlined rounded>
          <download-excel
            class="mr-2 pb-3 pt-2"
            :data="mainList"
            :fields="table_fields"
            worksheet="Student_List"
            name="SubjectRegistrationData.xls"
          >
            <v-icon dark>mdi-file-excel</v-icon> Export
          </download-excel>
        </v-btn> -->
        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'InstructorSubRegs')"
          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        <div id="my-table-id">
          <v-data-table v-if="mainList.length > 0" dense :headers="headers1" :items="mainList" :search="search"
            class="elevation-1 mytable">
          </v-data-table>
        </div>
      </span>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data() {
    return {
      fetch_loader: false,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      mainList: [],
      headers1: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Course Code",
          align: "center",
          sortable: false,
          value: "course_code",
        },
        {
          text: "Course Name",
          align: "center",
          sortable: false,
          value: "course_name",
        },
        {
          text: "Employee Name",
          align: "center",
          sortable: false,
          value: "employee_name",
        },
        {
          text: "Employee Code",
          align: "center",
          sortable: false,
          value: "employee_code",
        },
        {
          text: "Standard",
          align: "center",
          sortable: false,
          value: "standard",
        },
        {
          text: "Division",
          align: "center",
          sortable: false,
          value: "division",
        },
      ],
      table_fields: {
        "Sr. No": "srno",
        "Course Code": "course_code",
        "Course Name": "course_name",
        "Employee Name": "employee_name",
        "Employee Code": "employee_code",
        Standard: "standard",
        Division: "division",
      },
    };
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Course Code</th>
      <th>Course Name</th>
      <th>Employee Name</th>
      <th>Employee Code</th>
      <th>Standard</th>
      <th>Division</th>
      
    </tr>`;

  this.mainList.forEach((item, index) => {
    tab_text += `
      <tr>
        <td>${index + 1}</td>
        <td>${item.course_code}</td>
        <td>${item.course_name}</td>
        <td>${item.employee_name}</td>
        <td>${item.employee_code}</td>
        <td>${item.standard}</td>
        <td>${item.division}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},

    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.mainList = [];
    },
    getData() {
      this.fetch_loader = true;
      let ay;
      let div = this.div.div_id;
      let standard = this.sel_std_data.std_id;

      if (this.sel_ay_data.ay_id) {
        ay = this.sel_ay_data.ay_id;
      } else if (this.sel_ay_data.id) {
        ay = this.sel_ay_data.id;
      }
      if (this.div.div_id) {
        div = this.div.div_id;
      } else {
        div = this.div;
      }

      const formData = {
        ay: ay,
        division: div,
        standard: standard,
      };
      axios
        .post("/Examination/getInstructorCourse", formData)
        .then((res) => {
          if (res.data.employee_list.length != 0) {
            this.mainList = res.data.employee_list;
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          ay = null;
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}

.exportbtn {
  margin-bottom: 10px;
}
</style>
